module.exports = __webpack_public_path__ + "static/media/logo_icon.6dc97cf7.svg";